<template>
  <div>
    <div class="page-content">
      <div class="container-fluid background">
        <div class="row">
          <img src="~@/assets/images/brick-wall.jpg" alt="Van" class="col-12 p-0">
        </div>
      </div>
      <div class="container content">
        <div class="row">

          <div class="col-12">
            <h1 class="page-header">
              Contact Us
              <hr />
            </h1>
          </div>
          <div class="col-12">
            <p>
              <strong>
                For your free no obligation quote, get in touch today
              </strong>
            </p>
            <p>
              Simply fill out the form below and we'll get back to you promptly.
            </p>
          </div>
          <div class="col-lg-8">
            <div class="contact-form">
              <div v-if="errors.length" class="errors">
                <p>Please correct the following error(s):</p>
                <ul>
                  <li v-for="error in errors" :key="error">
                    {{ error }}
                  </li>
                </ul>
              </div>
              <div v-if="success" class="success">
                <b>Your message has been sent successfully</b>
              </div>
              <netlify-form name="contact-form" netlify-honeypot="bot-field">
                <div class="row">
                  <div class="col-md-6">
                    <label for="first-name" class="required">First name</label>
                    <input
                      v-model="firstName"
                      name="firstName"
                      id="first-name"
                      class="form-control"
                      type="text"
                      placeholder="Your first name"
                    />
                  </div>
                  <div class="col-md-6 mt-4 mt-md-0">
                    <label for="last-name" class="required">Last name</label>
                    <input
                      v-model="lastName"
                      name="lastName"
                      id="last-name"
                      class="form-control"
                      type="text"
                      placeholder="Your last name"
                    />
                  </div>
                  <div class="col-md-6 mt-4">
                    <label for="email-name" class="required">Email</label>
                    <input
                      v-model="email"
                      name="email"
                      id="email-name"
                      class="form-control"
                      type="email"
                      placeholder="Your email"
                    />
                  </div>
                  <div class="col-md-6 mt-4">
                    <label for="phone" class="required">Phone</label>
                    <input
                      v-model="phone"
                      name="phone"
                      id="phone"
                      class="form-control"
                      type="text"
                      placeholder="Your phone"
                    />
                  </div>
                  <div class="col-md-12 mt-4">
                    <label for="message" class="required">Your message</label>
                    <textarea
                      v-model="message"
                      name="message"
                      id="message"
                      class="form-control"
                      placeholder="Your message"
                      rows="5"
                    ></textarea>
                  </div>
                  <div class="col-md-12 mt-4">
                    <label class="required">GDPR Agreement</label>
                    <label id="chckbox-label" for="email-chkbox">
                      <input
                        v-model="gdpr"
                        type="checkbox"
                        name="checkbox"
                        id="email-chkbox"
                        required
                      />
                      <span>I consent to having this website store my submitted information so they can respond to my enquiry.</span>
                    </label>
                  </div>
                  <div class="col-md-12 mt-4">
                    <button
                      @click="onSubmit"
                      type="submit"
                      class="form-button btn"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </netlify-form>
            </div>
          </div>
          <div class="col-lg-4 mt-5 mt-lg-0">
            <div class="row">
              <div class="phone-email col-lg-12">
                <p>
                  <strong>Phone Number</strong> <br />
                  T:
                  <a href="tel:07842819256">07842 819256</a>
                </p>
                <hr>
                <p>
                  E:
                  <a href="mailto:enquiries@ashfieldbrickwork.co.uk">
                    enquiries@ashfieldbrickwork.co.uk
                  </a>
                </p>
              </div>

              <div class="row">
        </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NetlifyForm from '@/components/forms/NetlifyForm'

export default {
  name: 'contact-us',
  components: {
    NetlifyForm
  },
  data () {
    return {
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
      message: null,
      gdpr: false,
      errors: [],
      success: false
    }
  },
  methods: {
    onSubmit (e) {
      this.errors = []
      this.success = false

      if (!this.firstName) {
        this.errors.push('First Name required')
      }
      if (!this.lastName) {
        this.errors.push('Last Name required')
      }
      if (!this.email) {
        this.errors.push('Email required')
      } else if (!this.validEmail(this.email)) {
        this.errors.push('Valid email required')
      }
      if (!this.phone || !this.validPhoneNumber(this.phone)) {
        this.errors.push('Valid phone number required')
      }
      if (!this.message) {
        this.errors.push('Message required')
      }
      if (!this.gdpr) {
        this.errors.push(
          'We are unable to submit your enquiry, without consent to hold your data'
        )
      }
      if (this.errors.length) {
        e.preventDefault()
      }
    },
    validEmail: function (email) {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    validPhoneNumber: function (phoneNumber) {
      phoneNumber = phoneNumber.replace(/[()]+/g, '')
      let number = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/
      return number.test(phoneNumber)
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";
/****************************
    BANNER
*****************************/
.background {
  margin-top: -64px;
  width: 100%;
  height: 430px;
  border-bottom: 3px solid $primary;

  @media screen and (max-width: $md-breakpoint) {
    height: 300px;
  }

  .row {
    height: 100%;
  }

  .row img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

/****************************
    FORM
*****************************/
.content {
  margin-top: 64px;
}

.page-content {
  border-bottom: 3px $primary solid;
}

label {
  font-weight: 600;
}

.errors,
.success {
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 30px;
}

.success {
  color: #1c723d;
  background-color: #d7f8e5;
  border-color: #c6f5d6;
}

.errors {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}

.required {
  &::after {
    content: "*";
    color: #ce1426;
  }
}

.phone-email,
.address {
  display: flex;
  flex-direction: column;
  justify-content: center;
  p {
    margin: 0;
  }
  hr {
    margin: 10px 0;
  }
}

textarea {
  min-height: 135px;
}

input,
textarea {
  &:not([type="checkbox"]) {
    &:focus {
      border-color: $primary;
      outline: 0;
      -webkit-box-shadow: 0 0 0 0.2rem rgba(57, 173, 121, 0.25);
      box-shadow: 0 0 0 0.2rem rgba(57, 173, 121, 0.25);
    }
  }
}

#chckbox-label {
  display: flex;
  gap: 15px;
  cursor: pointer;
}

input[type="checkbox"] {
  cursor: pointer;
  /* Add if not using autoprefixer */
  -webkit-appearance: none;
  /* Remove most all native input styles */
  appearance: none;
  /* For iOS < 15 */
  background-color: var(--form-background);
  /* Not removed via appearance */
  margin: 0;

  font: inherit;
  color: currentColor;
  min-width: 24px;
  width: 24px;
  height: 24px;
  border: 1px solid #ced4da;
  border-radius: 2.4px;
  transform: translateY(-1.2px);

  display: grid;
  place-content: center;
}

input[type="checkbox"]::before {
  content: "";
  width: 12px;
  height: 12px;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  transform: scale(0);
  transform-origin: bottom left;
  transition: 120ms transform ease-in-out;
  box-shadow: inset 16px 16px var(--form-control-color);
  /* Windows High Contrast Mode */
  background-color: $white;
}

input[type="checkbox"]:checked {
  background-color: $primary;
}

input[type="checkbox"]:checked::before {
  transform: scale(1);
}

input[type="checkbox"]:focus {
  outline: none;
  outline-offset: 0;
}

input[type="checkbox"]:disabled {
  --form-control-color: var(--form-control-disabled);

  color: var(--form-control-disabled);
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/ContactUs.vue